import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { AuthService } from 'src/app/core/auth/auth.service';
import { ApiService } from 'src/app/core/http/api.service';
import { I18nService } from 'src/app/shared/services/i18n.service';
import { Utilities } from 'src/app/core/tools/utilities';
import { ApiCore } from '../../../../config/api';
import { HeaderCreditsService } from '../../Services/header-credits.service';
import { Subscription } from 'rxjs';
import { AppBreadcrumbService } from '../../Services/app.breadcrumb.service';
import { SessionService } from 'src/app/core/auth/session.service';
import { MobileAgentService } from 'src/app/shared/services/mobile-agent.service';
import { CommunicationService } from 'src/app/shared/services/communication.service';

@Component({
  selector: 'app-header-credits',
  templateUrl: './header-credits.component.html',
  styleUrls: ['./header-credits.component.css'],
})
export class HeaderCreditsComponent implements OnInit, OnDestroy {
  isClose: boolean = true;
  @Output() messageEvent = new EventEmitter<boolean>();
  alertIncompleteData = false;
  isIncomplete: boolean = false;

  items: MenuItem[] = [];
  profilePicture: any = 'assets/images/imageProfile.png';
  displaySidebar = false;
  iconSidebar = 'pi pi-cog';
  titleSidebar = 'Configuración';
  renderComponent = false;
  creditReserve = 0;
  bonusBalance = 0;
  operatorId: string = '';
  creditBalance = 0;
  public currencyCode: string = '';
  public currencyRegional: string = '';
  public currencySymbol: string = '';
  creditReserveSub: Subscription | undefined;
  bonusReserveSub: Subscription | undefined;

  bonusBalanceSub: Subscription | undefined;
  profilePictureSub: Subscription | undefined;

  hideCreditReserve: boolean = false;
  private subscription: Subscription = new Subscription();

  constructor(
    private i18nService: I18nService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private apiService: ApiService,
    private headerCreditsService: HeaderCreditsService,
    private breadcrumb: AppBreadcrumbService,
    private session: SessionService,
    public mobile: MobileAgentService,
    private readonly communication: CommunicationService,
    private cdr: ChangeDetectorRef
  ) {
    this.getOperatorConfigByOperatorId();
    this.i18nService.localeEvent.subscribe({
      next: () => {
        this.useTranslate();
      },
    });

    this.creditReserveSub = this.headerCreditsService.creditReserve.subscribe(
      (creditReserve) => {
        this.creditReserve = creditReserve;
      }
    );
    this.bonusBalanceSub = this.headerCreditsService.bonusBalance.subscribe(
      (bonusBalance) => {
        this.bonusBalance = bonusBalance;
      }
    );

    this.profilePictureSub = this.headerCreditsService.profilePicture.subscribe(
      (profilePicture) => {
        this.profilePicture = profilePicture;
      }
    );
  }
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  LoadUserData() {
    this.apiService.list(ApiCore.OPERATOR + '/me').subscribe(
      (res) => {
        if (res.data.profilePictureUrl) {
          this.profilePicture = res.data.profilePictureUrl;
        }
      },
      (error) => {}
    );
  }

  useTranslate() {
    this.translate.use(this.i18nService.getLanguage());
  }

  isClosedConfig = () => {
    this.messageEvent.emit(this.isClose);
  };

  ngOnInit(): void {
    const profileString = this.translate.instant('login.user');
    const logoutString = this.translate.instant('lobby.logout');
    this.headerCreditsService.creditAssignedSuccess$.subscribe(() => {
      this.getCreditBalance();
    });
    this.items = [
      {
        label: 'Mi Perfil',
        icon: 'pi pi-fw pi-user',
        command: () => this.openProfile(),
        routerLink: '/app/auth/profile',
        visible:
          this.auth.getPermission('Perfil de Agent Mobile') &&
          !(this.mobile.isMobileAgent() && this.mobile.isMobileDevice()),
      },
      {
        label: 'Configuración',
        icon: 'pi pi-fw pi-cog',
        command: () => this.openConfig(),
        visible: this.auth.getPermission('Configuración'),
      },
      {
        label: 'Cerrar Sesión',
        icon: 'pi pi-fw pi-sign-out',
        command: () => this.logout(),
      },
    ];
    this.getCreditReserveValue();
    //this.getBalanceBounusValue();
    this.getOperatorId();
    this.getCreditBalance();
    this.subscription = this.communication.changeEmitted$.subscribe(
      (res: any) => {
        if (res.walletUpdated === true) {
          this.getCreditReserveValue();
        }
      }
    );

    this.LoadUserData();

    let routeData = this.route.snapshot.children[0].data;
    this.hideCreditReserve = routeData['hideCreditReserve'] ?? false;

    this.creditReserveSub = this.headerCreditsService.creditReserve.subscribe(
      (creditReserve) => {
        this.creditBalance = creditReserve;
        setTimeout(() => {}, 0);
        this.cdr.detectChanges();
      }
    );

    this.bonusReserveSub = this.headerCreditsService.bonusReserve.subscribe(
      (bonusReserve) => {
        this.bonusBalance = bonusReserve;
        setTimeout(() => {}, 0);
        this.cdr.detectChanges();
      }
    );
  }

  openProfile() {}
  openConfig = () => {
    this.displaySidebar = true;
    this.renderComponent = true;
    //this.router.navigate(['/app/configuration']);
  };

  closeConfig = () => {
    this.displaySidebar = false;
  };

  onCloseConfig = () => {
    this.renderComponent = false;
    this.isClosedConfig();
  };

  logout() {
    this.auth.logout();
  }

  getOperatorConfig = (operatorId?: string) => {
    this.apiService.GetOperatorConfig(/*operatorId*/).subscribe((response) => {
      const {
        timeZoneCatId,
        languageCatId,
        logoUrl,
        casinoName,
        logoCasinoUrl,
        contactEmail,
        // countryCodeId,
        // contactPhone,
        // mesaggingServices,
        timeZoneCasinoCatId,
        languageCasinoCatId,
      } = response.data;
      let requeredConfigData = {
        operator: {
          timeZoneCatId,
          languageCatId,
          logoUrl,
        },
        casino: {
          casinoName,
          logoCasinoUrl,
          // countryCodeId,
          // contactPhone,
          // mesaggingServices,
          timeZoneCasinoCatId,
          languageCasinoCatId,
        },
      };
      this.currencyCode = response.data.currencyCode;
      this.currencyRegional = response.data.currencyRegional;
      this.currencySymbol = response.data.currencySymbol;
      //requeredConfigData.casino.casinoName = null;
      let operator = Utilities.hasNull(requeredConfigData.operator);
      let casino = Utilities.hasNull(requeredConfigData.casino);
      if (operator || casino) {
        this.alertIncompleteData = true;
        this.isIncomplete = true;
      }
    });
  };

  goToConfig = (data: boolean) => {
    this.router.navigate(['/app/configuration'], {
      queryParams: { incomplete: data },
    });
  };

  getCreditReserveValue = () => {
    if (this.auth.isAgent()) {
      this.apiService
        .list(ApiCore.DASHLET + 'general-balance')
        .subscribe((res) => {
          this.creditReserve = res.data[0].creditBalance;
        });
    } else {
      this.apiService
        .list(ApiCore.DASHLET + 'creditReserve')
        .subscribe((res) => {
          this.creditReserve = res.data[0].amount;
        });
    }
  };
  private getOperatorId(): void {
    this.apiService.getOperatorId(this.auth.getToken()).subscribe({
      next: (res) => {
        this.operatorId = res.data.operatorId;
        this.getBalanceBounusValue();
      },
    });
  }

  getBalanceBounusValue = () => {
    this.apiService
      .list(ApiCore.DASHLET + 'bonuses-balance', {
        operatorId: this.operatorId ?? '',
        merchantFilter: this.auth.isMerchantAgent()
          ? this.auth.getUserId()
          : '',
      })
      .subscribe((res) => {
        if (res?.data?.balanceBonus) {
          this.bonusBalance = res?.data?.balanceBonus ?? 0;
        } else {
          this.bonusBalance = res?.data?.bonus ?? 0;
        }
      });
  };
  getCreditBalance = () => {
    // this.loadButton = true;
    this.apiService
      .list(
        `${ApiCore.DASHLET}general-balance`,
        this.auth.isMerchantAgent()
          ? { operatorUserId: this.auth.getUserId() }
          : null
      )
      .subscribe((response) => {
        console.log(response);
        if (response?.data[0]?.creditBalance) {
          this.creditBalance = response.data[0].creditBalance;
        } else {
          this.creditBalance = response.data[0].credits;
        }
      });
  };
  getOperatorConfigByOperatorId = () => {
    const token: any = this.session.getItem('token');
    this.apiService.getOperatorId(token).subscribe({
      next: (res) => {
        this.session.setItem('o60pf2u4s9i5db', res.data.operatorId);
        this.getOperatorConfig(/*res.data.operatorId*/);
      },
    });
  };

  isAgent() {
    return this.auth.isAgent();
  }
}
